/**
 * "just now", "5 minutes ago", "yesterday", "3 days ago" — how long ago a
 * stored time was. A time slightly ahead of this device's clock reads
 * "just now", never a negative count.
 */
export function timeAgo(timestamp: string, now: number = Date.now()): string {
  const minutes = Math.floor((now - new Date(timestamp).getTime()) / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "yesterday";
  return `${days} days ago`;
}
